import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketOpenFreightQuoteEventName = 'OPEN_FREIGHT_QUOTE';

export const useTrackOpenFreightQuote = (): (() => void) => {
  return useCallback(() => {
    const environment = process.env.NODE_ENV || 'development';
    LogRocket.track(logRocketOpenFreightQuoteEventName, {
      env: environment,
    });
  }, []);
};
